import {JetView} from "webix-jet"; // Importing JetView from webix-jet framework
import {allpayments} from "models/allpayments"; // Importing allpayments model
import {devConfig} from "config/config"; // Importing development configuration

/**
 * Class representing the casino report view.
 * @extends JetView
 */
export default class tableCasinoReportView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        const _ = this.app.getService("locale")._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var direction = false; // Variable to hold sorting direction
        var vthis=this; // Reference to the current instance
        const cur_user = this.getParam("user", true); // Get current user parameter

        /**
         * Formats a percentage value.
         * @param {number} value - The value to format.
         * @returns {string} Formatted percentage string.
         */
        function percentFormat(value) {
            return webix.i18n.numberFormat(value) + "%"; // Format value as percentage
        }

        // Custom data filter for summing tree column values
        webix.ui.datafilter.summTreeColumn = webix.extend({
            refresh: function (master, node, value) {
                var result = 0; // Initialize result variable
                var resultFormat = 0; // Initialize formatted result variable
                master.data.each(function (obj) {
                    if (obj.$level == 1) result += obj[value.columnId]; // Sum values at level 1
                });
                // Format result based on column type
                if (value.columnId === 'Bets') {
                    resultFormat = webix.i18n.intFormat(result);
                } else {
                    resultFormat = webix.i18n.priceFormat(result);
                }
                node.firstChild.innerHTML = resultFormat; // Update node with formatted result
            }
        }, webix.ui.datafilter.summColumn); // Extend summColumn filter

        // Custom data filter for summing column values
        webix.ui.datafilter.mySummColumn = webix.extend({
            refresh:function(master, node, value){
                var result = 0; // Initialize result variable
                var resultFormat = 0; // Initialize formatted result variable
                var size = $$('datatable').getPager().config.size; // Get page size
                var page = $$('datatable').getPage(); // Get current page
                var first = size*page; // Calculate first item index
                var last = (first + size) - 1; // Calculate last item index
                var count = 0; // Initialize count variable
                master.data.each(function(obj){
                    if(count>=first && count<=last){
                        result +=  parseFloat(obj[value.columnId]) // Sum values within current page
                    }
                    count++;
                });
                resultFormat = webix.i18n.priceFormat(result); // Format result
                node.firstChild.innerHTML = resultFormat; // Update node with formatted result
            }
        }, webix.ui.datafilter.summColumn); // Extend summColumn filter

        return {
            rows: [{
                cols: [
                    {
                        view: "treetable", id: "datatable", // Define a tree table view
                        css: "webix_header_border webix_data_border webix_footer_border", // CSS classes for styling
                        select: true, // Enable row selection
                        columns: [
                            {
                                id: "ProviderNameGroup", header: _("Proveedor"), // Column for provider name group
                                fillspace: 0, minWidth: 0, width: 200, // Column dimensions
                                sort: "text", format: dateFormat, // Sorting and formatting
                                template: function (obj, common) {
                                    if (obj.$group) return common.treetable(obj, common) + obj.value; // Group template
                                    return obj.ProviderName; // Default template
                                }
                            },
                            {
                                id: "detailTittle", header: "", width: 50, height: 25, tooltip: _("Detalles"), // Column for details
                                template: function (obj) {
                                    return "<span class='webix_icon wxi-close details'></span>"; // Detail icon
                                }, footer: _("Total:") // Footer label
                            },
                            {id: "Id", header: "Id", width: 150, sort: "int"}, // Column for ID
                            {id: "Date", header: _("Fecha"), width: 150, sort: "int"}, // Column for date
                            {id: "Username", header: _("Usuario"), width: 250, sort: "int"}, // Column for username
                            {id: "Game", header: _("Juego"), width: 250, sort: "int"}, // Column for game
                            {id: "Identifier", header: _("Identificador"), width: 100, sort: "int"}, // Column for identifier
                            {id: "ProviderName", header: _("Proveedor"), width: 100, sort: "int"}, // Column for provider name
                            {id: "Bets", header: _("Cantidad"), width: 200, sort: "int", footer: {content: "summColumn"}}, // Column for bets
                            {
                                id: "TaxBet",
                                header: _("Impuesto Apuesta"),
                                format: webix.i18n.priceFormat, exportType:"number", // Format and export type
                                footer: {content: "summColumn"}, // Footer content
                                width: 200, sort: "int" // Column dimensions
                            },
                            {
                                id: "Tax",
                                header: _("Impuesto Premios"),
                                format: webix.i18n.priceFormat, exportType:"number", // Format and export type
                                footer: {content: "summColumn"}, // Footer content
                                width: 200, sort: "int" // Column dimensions
                            },
                            {
                                id: "Stakes",
                                header: _("Apuestas"),
                                format: webix.i18n.priceFormat, exportType:"number", // Format and export type
                                width: 200,
                                footer: {content: "summTreeColumn"}, // Footer content
                                sort: "int" // Sorting type
                            },
                            {
                                id: "FreeBalance",
                                header: _("Saldo Gratis"),
                                format: webix.i18n.priceFormat, exportType:"number", // Format and export type
                                width: 200,
                                footer: {content: "summTreeColumn"}, // Footer content
                                sort: "int" // Sorting type
                            },
                            {
                                id: "Winnings",
                                header: _("Premios"),
                                format: webix.i18n.priceFormat, exportType:"number", // Format and export type
                                footer: {content: "summTreeColumn"}, // Footer content
                                width: 200,
                                sort: "int" // Sorting type
                            },
                            {
                                id: "Bonus",
                                header: _("Bonos"),
                                width: 200,
                                footer: {content: "summTreeColumn"}, // Footer content
                                format: webix.i18n.priceFormat, exportType:"number", // Format and export type
                                sort: "int" // Sorting type
                            },
                            {
                                id: "Profit",
                                header: _("GGR"),
                                format: webix.i18n.priceFormat, exportType:"number", // Format and export type
                                footer: {content: "summTreeColumn"}, // Footer content
                                width: 200,
                                sort: "int" // Sorting type
                            },
                            {
                                id: "WinningsBonus",
                                header: _("Premios Bonos"),
                                width: 200,
                                sort: "int",
                                footer: {content: "summTreeColumn"}, // Footer content
                                format: webix.Number.numToStr({
                                    groupDelimiter: ",",
                                    groupSize: 3,
                                    decimalDelimiter: ".",
                                    decimalSize: 2
                                }) // Custom number formatting
                            },
                            {id: "Profitness", header: _("Beneficio %"), format: percentFormat, width: 100, sort: "int"} // Column for profit percentage
                        ],
                        onClick: {
                            "details": function (euv, id) {
                                var item = this.getItem(id); // Get clicked item
                                this.$scope.app.callEvent("user:id", [item.Id]); // Trigger user ID event
                                // Show details based on screen size
                                if(screen.width < 500 || screen.height < 500){
                                    $$("filterDetails").show();
                                }else{
                                    $$("dColl").expand();
                                }
                            },
                        },
                        on: {
                            onBeforeLoad: function () {
                                // Show loading overlay before data load
                                this.showOverlay("<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>");
                            },
                            onAfterLoad: function () {
                                this.hideOverlay(); // Hide loading overlay after data load
                            }
                        },
                        ready: function () {
                            // Show no data overlay if no items are present
                            if (!this.count()) {
                                webix.extend(this, webix.OverlayBox);
                                this.showOverlay("<div class='no-data' style='margin:75px; font-size:18px;'>" + _('No hay datos') + "</div>");
                            }
                        },
                        footer: true, // Enable footer
                        tooltip: true, // Enable tooltips
                        math: true, // Enable math calculations
                        loadahead: devConfig.getDefaultDataFetch(), // Set data fetch configuration
                        pager: "pagerA" // Set pager ID
                    }
                ]
            }
            ]
        };
    }

    /**
     * Initializes the grid and sets up event handlers.
     * @param {Object} grid - The grid instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the grid instance
        const cur_user = this.getParam("user", true); // Get current user parameter
        var url = devConfig.geturlApi() + "null/Report/GetCasinoGamesReport?PlayerId=" + cur_user + "&"; // API URL for fetching report
        var filter = ""; // Initialize filter variable
        var totales = false; // Initialize totals flag

        // Event handler for after data load
        grid.attachEvent("onAfterLoad", function () {
            if (totales) {
                // Group data by provider name if totals flag is true
                $$("datatable").data.group({
                    by: function (obj) {
                        return obj.ProviderName // Grouping function
                    },
                    map: {
                        ProviderName: ["ProviderName"],
                        Profit: ["Profit", "sum"],
                        Bets: ["Bets", "sum"],
                        Stakes: ["Stakes", "sum"],
                        FreeBalance: ["FreeBalance", "sum"],
                        Winnings: ["Winnings", "sum"],
                        Bonus: ["Bonus", "sum"],
                        WinningsBonus: ["WinningsBonus", "sum"],
                        Profitness: ["Profitness", function (prop, data) {
                            console.log("data:: ", data); // Log data for debugging
                            if (!data.length) return 0; // Return 0 if no data
                            var summ1 = 0; // Initialize sum1
                            var summ2 = 0; // Initialize sum2
                            for (var i = data.length - 1; i >= 0; i--) {
                                summ1 = summ1 + (Math.floor(data[i].Stakes)); // Sum stakes
                                summ2 = summ2 + (Math.floor(data[i].Profit)); // Sum profit
                            }
                            return (summ2 / summ1) * 100; // Calculate profit percentage
                        }],
                    }
                });
            }
        });

        // Event handler for filtering data
        this.on(this.app, "casinoReport:filter", filterData => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ""; // Initialize filter string
            totales = false; // Reset totals flag
            for (var i = 0; i < object.length; i++) {
                if (object[i][0] == "Type") {
                    // Show/hide columns based on type
                    if (object[i][1] == 0) {
                        grid.showColumn("Id", {spans: true});
                        grid.showColumn("Date", {spans: true});
                        grid.showColumn("Username", {spans: true});
                        grid.showColumn("detailTittle", {spans: true});
                        grid.hideColumn("ProviderNameGroup", {spans: true});
                        $$("datatable").data.ungroup(); // Ungroup data
                    } else {
                        grid.hideColumn("Id", {spans: true});
                        grid.hideColumn("Date", {spans: true});
                        grid.hideColumn("Username", {spans: true});
                        grid.hideColumn("detailTittle", {spans: true});
                        grid.showColumn("ProviderNameGroup", {spans: true});
                        $$("datatable").clearAll(); // Clear data
                        totales = true; // Set totals flag
                    }
                }
                if ((typeof object[i][1] !== "object") && (object[i][1] !== "")) {
                    // Build filter string based on filter data
                    if (object[i][0] == "Datepicker") {
                        var date = object[i][1].split(" - "); // Split date range
                        console.log(date); // Log date for debugging
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                      if(object[i][0] != "Date"){
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append filter parameter
                      }else{
                        if (object[i][0] == "Date") {
                          var date = object[i][1].replace(" 00:00:00","");
                          string1 = string1 + '&dateFrom=' + date;
                          string1 = string1 + '&dateTo=' + date;
                        }
                      }
                    }
                } else {
                    if ((typeof object[i][1] === "object")) {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                // Build date filter parameters
                                if (object2[j][0] === "start") {
                                    var d = new Date(object2[j][1]);
                                    var dateFrom = "MinCreatedLocal=" + ((d.getFullYear())) + ":" + ("00" + (d.getMonth() + 1)).slice(-2) + ":" + ("00" + d.getDate()).slice(-2) + " " + ("00" + d.getHours()).slice(-2) + ":" + ("00" + d.getMinutes()).slice(-2) + ":" + ("00" + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append start date filter
                                } else {
                                    if (object2[j][0] === "end") {
                                        var d = new Date(object2[j][1]);
                                        var dateTo = "MaxCreatedLocal=" + ((d.getFullYear())) + ":" + ("00" + (d.getMonth() + 1)).slice(-2) + ":" + ("00" + d.getDate()).slice(-2) + " " + ("00" + d.getHours()).slice(-2) + ":" + ("00" + d.getMinutes()).slice(-2) + ":" + ("00" + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append end date filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&PlayerId=' + cur_user; // Append player ID to filter
            grid.clearAll(); // Clear grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filter
            filter = string1; // Update filter variable
        });

        // Event handler for sorting data
        grid.attachEvent("onAfterSort", function (by, dir, as) {
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir); // Load sorted data
        });

        // Event handler for player selection
        this.on(this.app, "player:select", id => {
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + id); // Load data for selected player
        });
    }
}

// FILE DOCUMENTED
